import React, { useContext, useEffect, useState } from 'react';
import {Image} from '@shopify/hydrogen';
import 'rc-slider/assets/index.css';
import Category from './filters/Category.client';
import Order from './filters/Order.client';
import Autor from './filters/Autor.client';
import Price from './filters/Price.client';
import Review from './filters/Review.client';
import Format from './filters/Format.client';
import Subject from './filters/Subject.client';
import Ages from './filters/Ages.client';
import Language from './filters/Language.client';
import Brand from './filters/Brand.client';
import Tags from './filters/Tags.client';
import { useAppSelector } from '../../lib/hooks';
import { SearchContext } from '../context/Search.client';

export default function Filtters({}) {
  const [isFixed, setIsFixed] = useState(false);
  const { parentSection } = useContext(SearchContext);

  useEffect(()=>{
    const handleScroll = ()=>{
      let scrollTop = window.scrollY;
      let scrollHeight = document.documentElement.scrollHeight;
      let fixedFrom = (scrollHeight * 5) / 100;
      let fixedUpTo = (scrollHeight * 60) / 100;
      let startFixed = (parentSection === 'search') ? 1500 : 4800;

      let searchDiv = document.getElementById('search-results');
      let rect = searchDiv.getBoundingClientRect();
      let topPosition = (rect.top + window.scrollY);
      
      if(parentSection === 'category' && scrollTop < topPosition){
        setIsFixed(false);
      }else if(scrollHeight < startFixed){
        setIsFixed(false);
      }else if((scrollTop > fixedFrom && scrollTop < fixedUpTo)){
        setIsFixed(true);
      }else{
        setIsFixed(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [])

  return (
    <>
      <div id='filters-panel' className={isFixed ? 'fixed-section' : ''}>
        <Order></Order>
        <Category></Category>
        <Tags></Tags>
        <Autor></Autor>
        <Price></Price>
        <Format></Format>
        <Brand></Brand>
        <Ages></Ages>
        <Language></Language>
      </div>
    </>
  );
}
